export default {
  attended: 'Atendidos',
  received: 'Recibidos',
};
